import { h } from 'preact'
import UserAvatar from '../../User/UserAvatar'

interface Props {
  id: number,
  username: string,
  email: string,
  avatar: string,
  url: string,
  isInvite: boolean
}

const UserCell = () => {
  return ({ id, username, email, avatar, url, isInvite }: Props) => {
    const user = {
      id,
      name: isInvite ? email : username,
      avatar: avatar || '',
      url
    }

    return (
      <div className={`team-overview__table-user ${isInvite ? 'qa-is-invite' : ''}`}>
        <UserAvatar user={user} openInNewTab style={{ width: '40px', height: '40px' }} />
        { isInvite ? <div className='team-overview__table-user__email'>{email}</div>
          : <a href={user.url} target='_blank' className='team-overview__table-user__link'>
            <div className='team-overview__table-user__username' >{username}</div>
            <div className='team-overview__table-user__email'>{email}</div>
          </a>}
      </div>
    )
  }
}

export default UserCell
